import { IBillFromContent, IInvoiceProjectDetails } from '~/types/server.types';
import dayjs from '~/common/dayjs';

export const formattedBillFrom = (details: IBillFromContent) => {
    if (!details) {
        return null;
    }
    const companyInfo = [details.company_phone_number, details.company_email]
        .filter(Boolean)
        .join(' | ');
    const address = details.company_address;
    const companyLocation = [
        address?.street_address,
        address?.city,
        address?.state,
        address?.zip_code
    ]
        .filter(Boolean)
        .join(', ');
    return [details.company_name, companyInfo, companyLocation]
        .filter(Boolean)
        .join('\n');
};

export const formattedProjectDetails = (details: IInvoiceProjectDetails) => {
    if (!details) {
        return null;
    }
    const firstLineDetails = [details.project_name, details.project_type]
        .filter(Boolean)
        .join(' | ');

    const secondLineDetails = [
        details.project_date &&
            dayjs.utc(details.project_date).format('ddd, MMM D, YYYY'),
        details.project_location
    ]
        .filter(Boolean)
        .join(' | ');

    return [firstLineDetails, secondLineDetails].filter(Boolean).join('\n');
};
